import type { ConditionalWrapperProps } from './ConditionalWrapper.types';

export const ConditionalWrapper = ({ children, condition, wrapper }: ConditionalWrapperProps) =>
  // biome-ignore lint/complexity/noUselessFragments: children is ReactNode and must be wrapped in a Fragment to be returned as JSX
  condition ? wrapper(children) : <>{children}</>;
